/** Ordem de categorias dentro de um grupo do método (despesas → investimento → cofres). */
export function splitGroupCategories(group) {
  const all = group.categories || [];
  const smoothingPots = all.filter((c) => c.is_smoothing_pot);
  const planCategories = all.filter((c) => !c.is_smoothing_pot);
  const isReserved = Boolean(group.is_pay_yourself_first);
  const investmentCategories = isReserved
    ? planCategories
    : planCategories.filter((c) => c.is_investment_category);
  const expenseCategories = isReserved
    ? []
    : planCategories.filter((c) => !c.is_investment_category);
  return [...expenseCategories, ...investmentCategories, ...smoothingPots];
}

export function groupKey(group) {
  return group.id || group.name;
}

/** Despesas por grupo: arquivadas só se tiverem gasto no ciclo. */
export function categoriesForExpensesByGroup(group) {
  return splitGroupCategories(group).filter(
    (cat) => !cat.is_archived || Number(cat.spent_eur ?? 0) > 0,
  );
}
